import { ListViewProps } from '@thoughtspot/radiant-react/widgets/table/table-list-view';
import { ListType } from '/@services/generated/graphql-types';

export interface ShareObjectConfig {
    objectId: string;
    objectType: ListType;
}

export enum TranslationsKeys {
    COLLECTIONS_LOADER = 'collections.loader.label',
    SEARCH_LABEL = 'SEARCH_LABEL',
    HEADER_TITLE = 'collections.header.title',
    SHARE_BUTTON = 'sharePanel.TITLE',
    CREATE_BUTTON = 'collections.button.create.label',
    COLLECTION_NAME_COLUMN = 'collection.table.column.name',
    COLLECTION_DESCRIPTION_COLUMN = 'collection.table.column.description',
    COLLECTION_MORE_OPTIONS_COLUMN = 'collection.table.more.column',
    MORE_ACTIONS_SHARE = 'collection.table.more.share',
    MORE_ACTIONS_DELETE = 'collection.table.more.delete',
    MORE_ACTIONS_EDIT = 'collection.table.more.edit',
    MORE_ACTIONS_OPEN = 'collection.table.more.open',
    MODAL_NAME_LABEL = 'collection.create.modal.name.label',
    MODAL_DESCRIPTION_LABEL = 'collection.create.modal.description.label',
    MODAL_ERROR = 'collection.create.modal.error',
    MODAL_LENGTH_ERORR = 'collection.create.modal.length.error',
    CREATE_MODAL_TITLE = 'collection.create.modal.title',
    CREATE_MODAL_SAVE = 'collection.create.modal.add',
    CREATE_MODAL_CANCEL = 'collection.create.modal.cancel',
    CREATE_COLLECTION_SUCCESS = 'collection.create.modal.result.success',
    CREATE_COLLECTION_FAILURE = 'collections.create.actions.failed',
    CREATE_ERROR = 'collections.create.error',
    CREATE_COLLECTION_LABEL = 'collection.createCollection.label',
    UPDATE_SUCCESS = 'collections.update.success',
    UPDATE_ERROR = 'collections.update.error',
    MOVE_SUCCESS = 'collections.move.success',
    MOVE_ERROR = 'collections.move.error',
    MOVE_PERMISSION_ERROR = 'collections.move.permissionError',
    ADD_SUCCESS = 'collections.add.success',
    DELETE_SUCCESS = 'collection.table.delte.success',
    SEARCH_ERROR = 'collections.saerch.error',
    COLLECTIONS_CREATED_COLUMN = 'collections.table.created',
    COLLECTIONS_AUTHOR_COLUMN = 'collections.table.author',
    COLLECTIONS_TYPE_COLUMN = 'collection.table.column.Type',
    COLLECTION_UPDATED_COLUMN = 'collection.table.column.edited',
    COLLECTION_DELETE_ERROR = 'collections.error.delete',
    COLLECTION_ADD_OBJECTS_ERROR = 'collections.add.objects.error',
    ADD_TO_COLLECTION_TITLE = 'collection.add.title',
    DELETE_MODAL_TITLE = 'collections.modal.delete.title',
    DELETE_MODAL_MESSAGE = 'collections.modal.delete.message',
    DELETE_MODAL_QUESTION = 'collections.modal.delete.question',
    DELETE_MODAL_KEEP_ALL = 'collections.modal.delete.keepAll',
    DELETE_MODAL_DELETE_ALL = 'collections.modal.delete.deleteAll',
    DELETE_CONFIRMATION_TITLE = 'collections.modal.deleteConfirmation.title',
    DELETE_CONFIRMATION_MESSAGE = 'collections.modal.deleteConfirmation.message',
    DELETE_CONFIRMATION_NO_ITEMS = 'collections.modal.deleteConfirmation.noItems',
    DELETE_CONFIRMATION_LOADING_STATS = 'collections.modal.deleteConfirmation.loadingStats',
    DELETE_CONFIRMATION_ERROR = 'collections.modal.deleteConfirmation.error',
    DELETE_CONFIRMATION_COLLECTIONS_COUNT_SINGULAR = 'collections.modal.deleteConfirmation.collectionsCount.singular',
    DELETE_CONFIRMATION_COLLECTIONS_COUNT_PLURAL = 'collections.modal.deleteConfirmation.collectionsCount.plural',
    DELETE_CONFIRMATION_LIVEBOARDS_COUNT_SINGULAR = 'collections.modal.deleteConfirmation.liveboardsCount.singular',
    DELETE_CONFIRMATION_LIVEBOARDS_COUNT_PLURAL = 'collections.modal.deleteConfirmation.liveboardsCount.plural',
    DELETE_CONFIRMATION_ANSWERS_COUNT_SINGULAR = 'collections.modal.deleteConfirmation.answersCount.singular',
    DELETE_CONFIRMATION_ANSWERS_COUNT_PLURAL = 'collections.modal.deleteConfirmation.answersCount.plural',
    DELETE_CONFIRMATION_MODELS_COUNT_SINGULAR = 'collections.modal.deleteConfirmation.modelsCount.singular',
    DELETE_CONFIRMATION_MODELS_COUNT_PLURAL = 'collections.modal.deleteConfirmation.modelsCount.plural',
    DELETE_CONFIRMATION_TABLES_COUNT_SINGULAR = 'collections.modal.deleteConfirmation.tablesCount.singular',
    DELETE_CONFIRMATION_TABLES_COUNT_PLURAL = 'collections.modal.deleteConfirmation.tablesCount.plural',
    DELETE_CONFIRMATION_VIEWS_COUNT_SINGULAR = 'collections.modal.deleteConfirmation.viewsCount.singular',
    DELETE_CONFIRMATION_VIEWS_COUNT_PLURAL = 'collections.modal.deleteConfirmation.viewsCount.plural',
    DELETE_CONFIRMATION_DATASETS_COUNT_SINGULAR = 'collections.modal.deleteConfirmation.datasetsCount.singular',
    DELETE_CONFIRMATION_DATASETS_COUNT_PLURAL = 'collections.modal.deleteConfirmation.datasetsCount.plural',
    DELETE_CONFIRMATION_PROMPT = 'collections.modal.deleteConfirmation.confirmPrompt',
    DELETE_CONFIRMATION_BACK = 'collections.modal.deleteConfirmation.back',
    DELETE_CONFIRMATION_TEXT = 'collections.modal.deleteConfirmation.text',
    DELETE_CONFIRMATION_VERIFICATION_TEXT = 'collections.modal.deleteConfirmation.verificationText',
    DELETE_SUCCESS_DELETE_ALL = 'collections.delete.success.deleteAll',
    DELETE_SUCCESS_MULTIPLE = 'collections.delete.success.multiple',
    DELETE_SUCCESS_SINGLE = 'collections.delete.success.single',
    MOVE_DIALOG_SUBMIT = 'collection.dialog.move.submit',
    ZERO_STATE_TITLE = 'collections.zeroState.title',
    ZERO_STATE_DESCRIPTION = 'collections.zeroState.description',
    REMOVE_MODAL_TITLE_SINGLE = 'collections.modal.remove.titleSingle',
    REMOVE_MODAL_TITLE_MIXED = 'collections.modal.remove.titleMixed',
    REMOVE_MODAL_TITLE_COLLECTIONS = 'collections.modal.remove.titleCollections',
    REMOVE_MODAL_CANCEL = 'collections.modal.remove.cancel',
    REMOVE_MODAL_REMOVE_BUTTON = 'collections.modal.remove.removeButton',
    REMOVE_MODAL_WARNING_MESSAGE_LINE1 = 'collections.modal.remove.warningMessageLine1',
    REMOVE_MODAL_COLLECTIONS_WARNING_MESSAGE_LINE1 = 'collections.modal.remove.collectionsWarningMessageLine1',
    REMOVE_MODAL_WARNING_MESSAGE_LINE2 = 'collections.modal.remove.warningMessageLine2',
    REMOVE_MODAL_COLLECTIONS_WARNING_MESSAGE_LINE2 = 'collections.modal.remove.collectionsWarningMessageLine2',
    REMOVE_MODAL_OBJECT_WARNING_MESSAGE_LINE1 = 'collections.modal.remove.objectWarningMessageLine1',
    REMOVE_MODAL_OBJECT_WARNING_MESSAGE_LINE2 = 'collections.modal.remove.objectWarningMessageLine2',
    REMOVE_MODAL_OBJECTS_WARNING_MESSAGE_LINE2 = 'collections.modal.remove.objectsWarningMessageLine2',
    REMOVE_MODAL_DYNAMIC_WARNING_MESSAGE_LINE1 = 'collections.modal.remove.dynamicWarningMessageLine1',
    REMOVE_OBJECT_MODAL_TITLE = 'collections.modal.removeObject.title',
    REMOVE_OBJECTS_MODAL_TITLE = 'collections.modal.removeObjects.title',
    DELETE_OBJECTS_MODAL_TITLE = 'collections.modal.deleteObjects.title',
    DELETE_OBJECT_MODAL_TITLE = 'collections.modal.deleteObject.title',
    DELETE_OBJECTS_MODAL_DESCRIPTION = 'collections.modal.deleteObjects.description',
    NOTIFICATION_OBJECT_REMOVED = 'collections.notification.objectRemoved',
    NOTIFICATION_OBJECTS_REMOVED = 'collections.notification.objectsRemoved',
    NOTIFICATION_COLLECTION_REMOVED = 'collections.notification.collectionRemoved',
    NOTIFICATION_COLLECTIONS_REMOVED = 'collections.notification.collectionsRemoved',
    NOTIFICATION_COLLECTIONS_AND_OBJECTS_REMOVED = 'collections.notification.collectionsAndObjectsRemoved',
    AND = 'and',
    EXPORT_BUTTON = 'EXPORT',
    IMPORT_BUTTON = 'IMPORT',
    EXPORT_MODAL_TITLE = 'exportDependents.title',
    EXPORT_ONLY = 'collections.export.only.object',
    EXPORT_WITH_DEPENDENCIES = 'collections.export.dependencies.label',
    EXPORT_ERROR = 'collections.export.error',
}

export enum DataTestIds {
    LOADER_DATA_TEST_ID = 'collections-container-loader',
    GRID_LAYOUT_TEST_ID = 'collections-grid-layot',
    TOAST_MESSAGE_TEST_ID = 'toast-message-collection',
    // add data test ids here.
}

export enum StyleConstants {
    PRIMARY_BUTTON = 'primary',
    SECONDARY_BUTTON = 'secondary',
    // add style constants here.
}

export interface CollectionType {
    id?: string;
    name?: string;
    description?: string;
    numUsers?: number;
    numObjects?: number;
    // Add other fields here as needed
}

export interface CollectionGridType {
    collections: CollectionType[];
    // Add other fields here as needed
}

// Collection List Props
export interface CollectionListProps {
    pageHeading?: string | React.ReactElement;
    pageText?: string | React.ReactElement;
    listViewProps: ListViewProps;
    className?: string;
    isModularHomeExperienceEnabled?: boolean;
}
